// A one-way channel from the report feed to the map overlay: hovering a report that knows where it
// happened pings that cell for a second. The overlay is imperative and lives outside React, so this is
// a module-level slot rather than a context - one live stage exists at a time.

let handler: ((cell: number | null) => void) | null = null;

export function setPingHandler(h: ((cell: number | null) => void) | null): void {
  handler = h;
}

/** Ping a terrain cell on the map, or pass null to clear the ping. */
export function pingCell(cell: number | null): void {
  handler?.(cell);
}
